<div class="custom-snackbar" rtlDiv>
    <div class="dflex" rtlDiv>
      @if(create_waiting){
        <div class='spinner-container'>
          <div class="spinner"></div>
        </div>
        <div>
          {{ 'WORKPLAN.SNACKBAR_WAITING' | translate }}
        </div>
      }
      @else if(create_completed){
        <img src="assets/images/workplans-page/success.svg" alt="success">
        <div>
          {{ (data.popup === 'collectionResult' ? (data.action === 'accept' ? 'COLLECTION_REPORT.SNACKBAR_SUCCESS_ACCEPT_EVENTS' : 'COLLECTION_REPORT.SNACKBAR_SUCCESS_DELETE_EVENTS') : 'WORKPLAN.SNACKBAR_SUCCESS') | translate }}
        </div>
      }
      @else if(create_failed){
        <img src="assets/images/workplans-page/attention.svg" alt="attention">
        <div class="error-header">
          <div>
            {{ (data.popup === 'collectionResult' ? (data.action === 'accept' ? 'COLLECTION_REPORT.SNACKBAR_FAILED_ACCEPT_EVENTS' : 'COLLECTION_REPORT.SNACKBAR_FAILED_DELETE_EVENTS') : 'WORKPLAN.SNACKBAR_FAILED') | translate }}
          </div>
          @if(error_messages && error_messages.length > 0){
            <button class="error-toggle-btn" (click)="toggleErrorDetails()" type="button">
              <mat-icon class="toggle-icon" [class.expanded]="showErrorDetails">
                {{ showErrorDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </button>
          }
        </div>
      }
    </div>
    <div class="close-btn" rtlDiv (click)="closeSnackbar()">
      <img class="close-img" src="assets/images/workplans-page/close-btn.svg">
    </div>
  </div>
  @if(showErrorDetails && create_failed && error_messages && error_messages.length > 0){
    <div class="error-details-container" rtlDiv>
      <div class="error-list" rtlDiv>
        @for (message of error_messages; track $index) {
          <div class="error-item" rtlDiv>
            @if (data.popup === 'collectionResult') {
              <span class="site-name">{{ message.bin_id ?? message.binId ?? message.bin_name ?? message.collection_id }}</span>
              <span class="error-separator">-</span>
              <span class="error-message">{{ (message.is_executed != 1 ? 'COLLECTION_REPORT.SNACKBAR_STATUS_NOT_EXECUTED' : 'COLLECTION_REPORT.SNACKBAR_STATUS_NOT_FINISHED') | translate }}</span>
            } @else {
              <span class="site-name">{{ message.site_name }}</span>
              <span class="error-separator">-</span>
              <span class="error-message">{{ currentLang != 'iw' ? message.creation_error_type_name : message.creation_error_type_name_hebrew }}</span>
            }
          </div>
        }
      </div>
    </div>
  }
